export default __webpack_public_path__ + "static/media/ETC.118031f6.svg";